module.exports = __webpack_public_path__ + "static/media/dot.bb13d82a.svg";